export const AUTHORIZATION_SENTINEL = 'VendorflowAuth'
export const NO_CUSTOM_HEADERS_SENTINEL = 'NoCustomHeaders'
